import RpcService       from '@/core/services/Rpc/RpcService';
import type RpcResponse from '@/core/services/Rpc/RpcResponse';
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

class SWPortalEmployeesDAO {

    static async getList(
      filters?: {
        pattern?: string
      },
      pagination?: RpcDataPagination,
      sort?: RpcDataSort
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('SWPortalEmployees.getList', filters, pagination, sort);
    }
}

export default SWPortalEmployeesDAO;
